// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__23CS2","left":"InfoRow_left__3dySo"};